interface ImageBg {
  thumbnailUrl: string;
  portraitUrl: string;
  landscapeUrl: string;
  premium?: boolean;
  hidden?: boolean;
}

export const imagesBg: Record<string, ImageBg> = {
  'image-teetsh': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_a9b1b48daf.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_804773341e.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_96f11f9f8d.png',
    premium: false,
    hidden: true,
  },
  'image-teetsh-2': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_1_3d03cada5e.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_1_503c68a9d9.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_1_5bad255a1d.png',
    premium: false,
  },
  'image-ecole': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_motif_ecole_12cedc7ac7.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Ecole_Portrait_2dbedbb83c.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Ecole_Paysage_b58bda2b4c.png',
    premium: true,
    hidden: true,
  },
  'image-ecole-2': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_3_f39f67bc22.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_3_4bf437d500.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_3_8a38238d27.png',
    premium: true,
  },
  'image-autumn': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_9_773f53a535.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_9_661c958617.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_9_a948f5b3ba.png',
    premium: true,
  },
  'image-halloween': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_10_44a34fa468.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_10_79eb238f45.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_10_f50bc3467f.png',
    premium: true,
  },
  'image-hiver': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_hiver_b9bc3bb8f2.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_hiver_portrait_abd1fd361a.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_hiver_paysage_7316de39ec.png',
    premium: true,
    hidden: true,
  },
  'image-hiver-2': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_12_0314840751.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_12_82b06c4a62.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_12_23f41190e5.png',
    premium: true,
  },
  'image-christmas': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/thumbnail_christmas_bg_96x96_996ef0c718.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/bg_christmas_2_adcb6e58a7.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/bg_christmas_2_landscape_c39c1f7faa.png',
    premium: false,
    hidden: true,
  },
  'image-christmas-2': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_11_ec23b3dd87.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_11_0d923d301d.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_11_a7482df98c.png',
    premium: false,
  },
  'image-love': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_6_d77cadd205.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_6_3e24ff7499.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_6_8602d180bd.png',
    premium: true,
  },
  'image-plantes': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_motif_plante_96px_7aa4e97a89.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Plantes_Portrait_Flyer_A4_9ac7341a53.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Plantes_Paysage_A4_c856090699.png',
    premium: true,
  },
  'image-sport': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_sportif_7198b81e64.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_sportif_portrait_68d92193cc.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_sportif_paysage_c56924eca1.png',
    premium: true,
    hidden: true,
  },
  'image-rainbow': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_arc_en_ciel_64a89200a6.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_arc_en_ciel_portrait_6aec430482.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_arc_en_ciel_paysage_ce115334f1.png',
    premium: true,
    hidden: true,
  },
  'image-rainbow-2': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_2_4291b73057.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_2_9ebbc53319.png?tr=q-100', // default quality is 80, so we set it to 100 for this one because it looks better
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_2_832561e5cc.png?tr=q-100', // default quality is 80, so we set it to 100 for this one because it looks better
    premium: true,
  },
  'image-shell': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_4_31391616a8.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_4_617b82a874.png?tr=q-100', // default quality is 80, so we set it to 100 for this one because it looks better
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_4_00ed56c573.png?tr=q-100', // default quality is 80, so we set it to 100 for this one because it looks better
    premium: true,
  },
  'image-lemon': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_5_abd6dc451f.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_5_c157780811.png?tr=q-100', // default quality is 80, so we set it to 100 for this one because it looks better
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_5_725a6b58b4.png?tr=q-100', // default quality is 80, so we set it to 100 for this one because it looks better
    premium: true,
  },
  'image-flower': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_7_490413e25f.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_7_f5181a6487.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_7_43f344c004.png',
    premium: true,
  },
  'image-flower-2': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_Teetsh_8_f17d3f26b3.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_portrait_8_ba34ef964e.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_Teetsh_paysage_8_486a932921.png',
    premium: true,
  },
  'image-nippon': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_nippon_9fd1b29d9b.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_nippon_portrait_9af4d1a387.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_nippon_paysage_cbe5e75c73.png',
    premium: true,
  },
  'image-geometrique': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_geometrique_88bcb68b69.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_geometrique_portrait_7ad4ffb2ab.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_geometrique_paysage_045e2d9312.png',
    premium: true,
  },
  'image-leopard': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_leopard_e2e4407962.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_leopard_portrait_b24b813d51.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_leopard_paysage_d6564fa904.png',
    premium: true,
  },
  'image-retro': {
    thumbnailUrl:
      'https://images.teetsh.com/strapi-assets/Vignette_retro_0b3273187c.png',
    portraitUrl:
      'https://images.teetsh.com/strapi-assets/Motif_retro_portrait_6156cd57f4.png',
    landscapeUrl:
      'https://images.teetsh.com/strapi-assets/Motif_retro_paysage_1802812951.png',
    premium: true,
    hidden: true,
  },
  white: {
    thumbnailUrl: '',
    portraitUrl: '',
    landscapeUrl: '',
    premium: false,
  },
};

export function extractBgColorOrImage(v?: string): {
  bgColor?: string;
  portraitBgUrl?: string;
  landscapeBgUrl?: string;
} {
  if (!v) {
    return {
      bgColor: 'white',
    };
  }
  if (v.startsWith('image-')) {
    const foundBg = imagesBg[v];
    if (!foundBg) {
      return {
        bgColor: 'white',
      };
    }
    return {
      portraitBgUrl: imagesBg[v].portraitUrl,
      landscapeBgUrl: imagesBg[v].landscapeUrl,
    };
  }
  return {
    bgColor: v,
  };
}
